<template>
  <div ref="loader" class="bottom-loader"></div>
</template>

<script>
export default {
  name: "bottom-loader",
  props: {
    stopCondition: { required: false, default: false, type: Boolean }
  },
  data() {
    return {
      observer: new IntersectionObserver(this.emitIntersection)
    };
  },
  methods: {
    emitIntersection(entries) {
      if (entries[0].intersectionRatio <= 0) return;
      if (this.stopCondition) return;
      this.$emit("intersection");
    }
  },
  mounted() {
    this.observer.observe(this.$refs.loader);
  },
  destroyed() {
    this.observer.disconnect();
  }
};
</script>

<style scoped>
.bottom-loader {
  position: absolute;
  width: 100%;
  height: 40px;
  bottom: 200px;
  z-index: -100;
}
</style>
